import axios from "axios"
import { useAppState } from "../redux"
import { useQuery } from "react-query"
import { QueryKeys } from "../../constants/query-keys"
import { useState } from "react"
import { FieldFilter } from "../../constants/filter-operators"

export type Sort = {
  field: string,
  direction: 'asc' | 'desc'
}

export const useReviewVersionMatches = (id: string) => {
  const appState = useAppState()
  const { csrf_timestamp, csrf_token, masterAccountId } = appState.session
  const limit = 50
  const [page, setPage] = useState(1)
  const [sort, setSort] = useState<Sort>({ field: 'org_job_code', direction: 'desc' }) // possibly save these in version table
  const [filters, setFilters] = useState<FieldFilter[]>([]) // possibly save these in version table

  const getVersionMatches = async (): Promise<any | undefined> => {
    let url = `/cms/api/accounts/${masterAccountId}/global-job-pricing/versions/${id}/review-matches?csrf_token=${csrf_token}&csrf_timestamp=${csrf_timestamp}`
    if (limit) url += `&limit=${limit}`
    if (page) url += `&page=${page}`
    if (sort?.field) url += `&sortBy=${sort.field}`
    if (sort?.direction) url += `&sortDir=${sort.direction}`
    if (filters.length) {
      url += `&filters=${JSON.stringify(filters.map(f => ({ sourceField: f.sourceField, operator: f.operator, value: f.value, type: f.type })))}`
    }
    const response = await axios.get(url)
    return response?.data?.data
  }

  const query = useQuery([QueryKeys.GLO_JAM_REVIEW_MATCHES, { id, limit, page, sort, filters }], getVersionMatches, { keepPreviousData: true })

  return { ...query, page, setPage, limit, sort, setSort, setFilters, filters }
}
